import * as React from 'react';

import { UserMenu } from '../../../../UserMenu';

import { HeaderUserMenuProps } from './types';

export const HeaderUserMenu: React.FC<HeaderUserMenuProps> = props => {
  const { headerData } = props;

  const handleLoginClick = React.useCallback<(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void>(
    event => {
      event.preventDefault();
      // eslint-disable-next-line no-unused-expressions
      window._headerTrackingEvent?.('login', 'eventSite');
      // eslint-disable-next-line no-unused-expressions
      window.waitForLoginPopup?.();
    },
    [],
  );

  return (
    <div id="header-user-menu" className="header-user-menu">
      {headerData.isAuthenticated ? (
        <UserMenu headerData={headerData} />
      ) : (
        <a id="login-btn" className="login-link" onClick={handleLoginClick} href="/authenticate/">
          <span>Войти</span>
        </a>
      )}
    </div>
  );
};

HeaderUserMenu.displayName = 'HeaderUserMenu';
